import { combineReducers } from 'redux';
import { loadingRedux,selectColegioRedux,setUsuarioRedux,selectAnioRedux } from './test'

const rootReducer = combineReducers({
  loading:loadingRedux,
  usuario:setUsuarioRedux,
  colegio:selectColegioRedux,
  anio:selectAnioRedux
});

export default rootReducer;